// extracted by mini-css-extract-plugin
export default {"error":"error-item_error__eLqNa","icon":"error-item_icon__1MU9l"};